import { Order } from '../../model/dto/order/order';

type MarketingField =
  | 'utm_source'
  | 'utm_medium'
  | 'utm_campaign'
  | 'utm_term'
  | 'utm_content'
  | 'where_did_you_hear_about_us';

export interface OrderMarketingValue {
  labelKey: string;
  value: string;
}

const MARKETING_FIELDS: { field: MarketingField; labelKey: string }[] = [
  { field: 'utm_source', labelKey: 'orders.generalInfo.utmSource' },
  { field: 'utm_medium', labelKey: 'orders.generalInfo.utmMedium' },
  { field: 'utm_campaign', labelKey: 'orders.generalInfo.utmCampaign' },
  { field: 'utm_term', labelKey: 'orders.generalInfo.utmTerm' },
  { field: 'utm_content', labelKey: 'orders.generalInfo.utmContent' },
  {
    field: 'where_did_you_hear_about_us',
    labelKey: 'orders.generalInfo.whereDidYouHearAboutUs',
  },
];

export const getOrderMarketingValues = (
  order: Pick<Order, MarketingField>
): OrderMarketingValue[] =>
  MARKETING_FIELDS.map(({ field, labelKey }) => ({
    labelKey,
    value: `${order[field] ?? ''}`.trim(),
  }));

export const countProvidedMarketingValues = (
  values: OrderMarketingValue[]
): number => values.filter(({ value }) => value !== '').length;
